import { render } from "./Configuration.vue?vue&type=template&id=563558e6&scoped=true"
import script from "./Configuration.vue?vue&type=script&lang=js"
export * from "./Configuration.vue?vue&type=script&lang=js"

import "./Configuration.vue?vue&type=style&index=0&id=563558e6&scoped=true&lang=css"
import "./Configuration.vue?vue&type=style&index=1&id=563558e6&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563558e6"]])

export default __exports__